/* EVAMATS — galeria: wybór marki (grey, 01.10.2026). Dane: <template data-evm-gal-tpl> z sections/section-gallery.liquid
   (artykuły „Nasze realizacje” danej marki). Szablon jest bezczynny — zdjęcia ładują się dopiero po wybraniu marki.
   „Wszystkie” pokazuje dotychczasową galerię (assets/gallery.js nie jest ruszany). Adres ?marka=<blog> otwiera markę od razu
   i zmienia się przy wyborze, więc link do konkretnej marki można wysłać klientowi.
   Kafelki marek to radiogroup: Tab wchodzi na wybraną markę, strzałki przechodzą do sąsiedniej i ją wybierają.
   Zwinięte kafelki (jeden rząd, na telefonie dwa) rozwija przycisk „Pokaż wszystkie marki”; wybór ukrytej marki
   (np. z linku) rozwija je sam. */
(function () {
  if (window.__evmGal) return;
  window.__evmGal = true;

  /* miniatury: Tilda ma własną usługę zmniejszania (thb…/-/resize/600x/), CDN Shopify — parametr width */
  function thumb(url, w) {
    if (!url) return url;
    if (/^\/\//.test(url)) url = 'https:' + url;
    if (/\/\/static\.tildacdn\.com\/tild[^/]+\//.test(url)) {
      return url.replace('//static.tildacdn.com/', '//thb.tildacdn.com/').replace(/(\/tild[^/]+\/)/, '$1-/resize/' + w + 'x/');
    }
    if (/\/\/cdn\.shopify\.com\/|\/cdn\/shop\//.test(url)) {
      return url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '') + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    return url;
  }

  function init(root) {
    if (root.__evmGal) return;
    root.__evmGal = true;
    var scope = root.closest('.gallery') || document;
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-evm-gal-brand]'));
    var moreBtn = root.querySelector('[data-evm-gal-more]');
    var general = scope.querySelector('[data-evm-gal-general]');
    var grid = scope.querySelector('[data-evm-gal-grid]');
    var results = scope.querySelector('[data-evm-gal-results]');
    if (!results) return;
    var list = results.querySelector('[data-evm-gal-list]');
    var title = results.querySelector('[data-evm-gal-title]');
    var nameEl = results.querySelector('[data-evm-gal-name]');
    var countEl = results.querySelector('[data-evm-gal-count]');
    /* 02.10: filtr rodzaju w marce (z rantami / bez rantów) — z data-rodzaj aut; pokazany tylko, gdy marka ma oba rodzaje.
       05.10 przegląd: rodzaje i liczniki z samych przycisków (bez wpisanych na sztywno kluczy); auto bez metapola nie ma
       data-rodzaj i liczy się tylko do „Wszystkie” — wcześniej liczyło się tam podwójnie. */
    var rodzajBox = results.querySelector('[data-evm-gal-rodzaj]');
    function applyRodzaj(val) {
      if (!rodzajBox) return;
      Array.prototype.forEach.call(rodzajBox.querySelectorAll('[data-rodzaj]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-rodzaj') === val ? 'true' : 'false'); });
      Array.prototype.forEach.call(list.querySelectorAll('.evm-gal-car'), function (car) { car.hidden = !!val && car.getAttribute('data-rodzaj') !== val; });
    }
    function setupRodzaj() {
      if (!rodzajBox) return;
      var cars = list.querySelectorAll('.evm-gal-car');
      var buttons = Array.prototype.slice.call(rodzajBox.querySelectorAll('[data-rodzaj]'));
      var kinds = buttons.map(function (b) { return b.getAttribute('data-rodzaj'); }).filter(Boolean);
      var n = {};
      kinds.forEach(function (k) { n[k] = 0; });
      Array.prototype.forEach.call(cars, function (c) { var r = c.getAttribute('data-rodzaj'); if (r && n.hasOwnProperty(r)) n[r]++; });
      n[''] = cars.length;
      buttons.forEach(function (b) { var el = b.querySelector('[data-n]'); if (el) el.textContent = '(' + n[b.getAttribute('data-rodzaj')] + ')'; });
      rodzajBox.hidden = !(kinds.length > 1 && kinds.every(function (k) { return n[k] > 0; }));
      applyRodzaj('');
    }
    if (rodzajBox) rodzajBox.addEventListener('click', function (e) { var b = e.target.closest('[data-rodzaj]'); if (b) applyRodzaj(b.getAttribute('data-rodzaj')); });
    var per = parseInt(root.getAttribute('data-per') || '4', 10) || 4;

    function visible(t) { return t.offsetParent !== null; }
    function setOpen(open) {
      root.classList.toggle('is-open', open);
      if (!moreBtn) return;
      moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      moreBtn.querySelector('span').textContent = moreBtn.getAttribute(open ? 'data-less' : 'data-more');
    }
    /* przycisk „pokaż wszystkie” ma sens tylko, gdy coś jest schowane */
    function syncMore() {
      if (!moreBtn) return;
      var hidden = !root.classList.contains('is-open') && tiles.some(function (t) { return !visible(t); });
      moreBtn.hidden = !hidden && !root.classList.contains('is-open');
    }

    function render(tpl) {
      var frag = tpl.content.cloneNode(true);
      Array.prototype.forEach.call(frag.querySelectorAll('.evm-gal-car'), function (car) {
        var name = car.getAttribute('data-title') || '';
        var photos = car.querySelectorAll('.evm-gal-car__photo');
        Array.prototype.forEach.call(photos, function (a, i) {
          var href = a.getAttribute('href');
          /* reszta zdjęć zostaje w DOM (ukryta) — powiększenie przewija wszystkie zdjęcia tego auta. Miniatura w pasku
             powiększenia to mały plik (05.10 przegląd: bez niej Fancybox brał oryginał, ~0,6 MB za każde ukryte zdjęcie) */
          a.setAttribute('data-thumb-src', thumb(href, 240));
          if (i >= per) { a.hidden = true; return; }
          var img = document.createElement('img');
          img.src = thumb(href, 600);
          img.srcset = thumb(href, 360) + ' 360w, ' + thumb(href, 600) + ' 600w, ' + thumb(href, 900) + ' 900w';
          img.sizes = '(min-width: 990px) 25vw, 50vw';
          img.alt = name;
          img.loading = 'lazy';
          img.decoding = 'async';
          img.width = 600;
          img.height = 450;
          a.appendChild(img);
          if (i === per - 1 && photos.length > per) {
            var more = document.createElement('span');
            more.className = 'evm-gal-car__more';
            more.setAttribute('aria-hidden', 'true');
            more.textContent = '+' + (photos.length - per);
            a.appendChild(more);
          }
        });
      });
      list.appendChild(frag);
    }

    /* ?marka=BMW, ?marka=Škoda, spacje, śmieci — sprowadzamy do uchwytu bloga; szablon szukamy porównaniem atrybutu,
       nie selektorem CSS (05.10 przegląd: „%0A” wywracał skrypt, a wielka litera dawała po cichu „Wszystkie”) */
    function toHandle(v) {
      return String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    function findTpl(handle) {
      var all = scope.querySelectorAll('template[data-evm-gal-tpl]');
      for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-evm-gal-tpl') === handle) return all[i];
      return null;
    }
    function show(handle, opts) {
      opts = opts || {};
      handle = toHandle(handle);
      var tpl = handle ? findTpl(handle) : null;
      if (handle && !tpl) handle = '';
      var current = null;
      var wasHidden = false;
      tiles.forEach(function (t) {
        var on = (t.getAttribute('data-evm-gal-brand') || '') === handle;
        /* widoczność sprawdzamy, zanim kafelek dostanie aria-checked (wybrany kafelek CSS zostawia widoczny po zwinięciu) */
        if (on) { current = t; wasHidden = !visible(t); }
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      if (current && wasHidden) setOpen(true);
      var on = !!handle;
      if (general) general.hidden = on;
      if (grid) grid.hidden = on;
      results.hidden = !on;
      list.textContent = '';
      if (on) {
        nameEl.textContent = tpl.getAttribute('data-name') || '';
        countEl.textContent = tpl.getAttribute('data-count') || '';
        render(tpl);
        setupRodzaj();
        if (opts.focus) title.focus({ preventScroll: true });
        /* po kliknięciu w rozwiniętych kafelkach wyniki są daleko w dole — przewijamy do nich (nie przy strzałkach) */
        if (opts.reveal) {
          var top = results.getBoundingClientRect().top;
          if (top > window.innerHeight * 0.7) {
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: top + window.pageYOffset - 96, behavior: reduce ? 'auto' : 'smooth' });
          }
        }
      }
      if (opts.url !== false && window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        if (on) u.searchParams.set('marka', handle); else u.searchParams.delete('marka');
        window.history.replaceState(window.history.state, '', u.toString());
      }
      syncMore();
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function (e) { show(t.getAttribute('data-evm-gal-brand') || '', { reveal: e.detail > 0 }); });
      t.addEventListener('keydown', function (e) {
        var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        var vis = tiles.filter(visible);
        var i = vis.indexOf(t);
        var j = null;
        if (keys[e.key]) j = (i + keys[e.key] + vis.length) % vis.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = vis.length - 1;
        if (j === null) return;
        e.preventDefault();
        show(vis[j].getAttribute('data-evm-gal-brand') || '');
        vis[j].focus();
      });
    });
    if (moreBtn) moreBtn.addEventListener('click', function () { setOpen(!root.classList.contains('is-open')); syncMore(); });
    window.addEventListener('resize', syncMore);

    var start = new URLSearchParams(window.location.search).get('marka');
    /* adres poprawiamy tylko, gdy marka była zapisana inaczej niż uchwyt (wielka litera, polska litera, nieznana) */
    if (start) show(start, { url: toHandle(start) !== start || !findTpl(toHandle(start)) }); else syncMore();
    if (scope.classList) scope.classList.remove('evm-gal-boot');
  }

  function boot(ctx) { Array.prototype.forEach.call((ctx || document).querySelectorAll('[data-evm-gal]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
